module.exports = __webpack_public_path__ + "img/arrow-red-down.1717cc2e.svg";